import { render, staticRenderFns } from "./home-invest-button.vue?vue&type=template&id=8e6e995a&scoped=true&"
import script from "./home-invest-button.vue?vue&type=script&lang=js&"
export * from "./home-invest-button.vue?vue&type=script&lang=js&"
import style0 from "./home-invest-button.vue?vue&type=style&index=0&id=8e6e995a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6e995a",
  null
  
)

export default component.exports